<button data-uit="send-feedback" type="button" class="btn btn-ghost" (click)="openFeedbackModal()">
    <ca-icon name="feedback" size="s" class="me-2"></ca-icon>
    <span class="text-nowrap">{{ 'GENERAL.FEEDBACK.SEND_FEEDBACK' | translate }}</span>
</button>
